var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _g2, _path13, _g3, _path14, _path15, _g4, _path16, _path17, _g5, _path18, _path19, _path20, _path21, _g6, _path22, _path23, _g7, _path24, _g8, _path25, _g9, _path26, _g10, _path27, _g11, _path28, _g12, _path29, _path30, _g13, _path31, _g14, _path32, _g15, _path33, _path34, _g16, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g17, _path47, _path48, _path49, _g18, _path50, _path51, _g19, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g20, _path95;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6801 8.78322V11.9512L22.5361 10.4392V7.19922L22.6801 8.78322Z",
    fill: "#D72F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1042 13.3195V16.5595C30.9602 15.1915 30.2402 14.1115 28.9442 13.3195C26.4962 11.8795 22.7522 11.9515 22.6802 11.9515V8.71153C22.7522 8.71153 26.4242 8.63953 28.9442 10.0795C30.2402 10.8715 30.9602 11.9515 31.1042 13.3195Z",
    fill: "#F74457"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2802 13.5352V16.7752C35.2802 16.8472 35.2802 16.9192 35.1362 16.9192V13.6792C35.2802 13.6072 35.2802 13.6072 35.2802 13.5352Z",
    fill: "#D72F40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.52 13.6792V16.9192C29.448 16.8472 29.376 16.8472 29.376 16.7752V13.5352C29.448 13.6072 29.448 13.6072 29.52 13.6792Z",
    fill: "#D72F40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1362 13.6797V16.9197L32.6162 18.3597V15.1917L35.1362 13.6797Z",
    fill: "#D72F40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.112 15.1917L32.04 18.3597L29.52 16.9197V13.6797L32.112 15.1917Z",
    fill: "#D72F40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.616 15.1914V18.4314C32.472 18.5034 32.184 18.5034 32.04 18.4314V15.1914C32.256 15.2634 32.472 15.2634 32.616 15.1914Z",
    fill: "#E53851"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7441 8.99959C32.5441 10.0796 33.5521 11.5196 33.6961 13.2476H34.8481C34.9921 13.2476 35.0641 13.2476 35.1361 13.3196C35.2801 13.3916 35.2801 13.5356 35.1361 13.6076L32.6161 15.0476C32.4721 15.1196 32.1841 15.1196 32.0401 15.0476L29.5201 13.6796C29.3041 13.5356 29.4481 13.3196 29.8081 13.3196H31.1041C30.9601 11.9516 30.2401 10.8716 28.9441 10.0796C26.4961 8.63959 22.7521 8.71159 22.6801 8.71159L22.5361 7.19959C22.7521 7.19959 27.5041 7.12759 30.7441 8.99959Z",
    fill: "#FF5766"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 10,
    height: 5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1594 22.5387C26.7114 21.0987 22.6794 21.0987 20.2314 22.5387C20.2314 21.6027 20.2314 20.7387 20.2314 19.8027C22.6794 18.3627 26.7114 18.3627 29.1594 19.8027C29.1594 20.7387 29.1594 21.6027 29.1594 22.5387Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0316 22.3951V25.1311C31.0316 23.6911 29.5916 22.6111 28.2236 22.1071V19.3711C28.5116 19.5151 28.8716 19.6591 29.1596 19.8031C30.3836 20.5231 31.0316 21.4591 31.0316 22.3951Z",
    fill: "#81703A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2236 19.37V22.106C28.0076 22.034 27.7196 21.89 27.4316 21.818V19.082C27.7196 19.226 28.0076 19.298 28.2236 19.37Z",
    fill: "#86743C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4317 19.0835V21.8195C27.2157 21.7475 26.9997 21.6755 26.7837 21.6755V18.9395C26.9997 19.0115 27.2157 19.0835 27.4317 19.0835Z",
    fill: "#8B783F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7835 18.9392V21.6752C26.5675 21.6032 26.3515 21.6032 26.2075 21.6032V18.8672C26.4235 18.8672 26.5675 18.9392 26.7835 18.9392Z",
    fill: "#907D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2076 18.8669V21.6029C25.9916 21.6029 25.7756 21.5309 25.5596 21.5309V18.7949C25.7756 18.7949 25.9916 18.7949 26.2076 18.8669Z",
    fill: "#958143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5596 18.7957V21.5317C25.3436 21.5317 25.1276 21.5317 24.9116 21.5317V18.7957C25.1276 18.7237 25.3436 18.7957 25.5596 18.7957Z",
    fill: "#9A8545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9117 18.7227V21.4587C24.6957 21.4587 24.4797 21.4587 24.2637 21.4587V18.7227C24.4797 18.7227 24.6957 18.7227 24.9117 18.7227Z",
    fill: "#9F8A48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2635 18.7227V21.4587C24.0475 21.4587 23.7595 21.4587 23.5435 21.5307V18.7947C23.8315 18.7947 24.0475 18.7227 24.2635 18.7227Z",
    fill: "#A48E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6157 18.7949V21.5309C23.3277 21.5309 23.0397 21.6029 22.8237 21.6749V18.9389C23.0397 18.8669 23.3277 18.7949 23.6157 18.7949Z",
    fill: "#A9924C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8236 18.9395V21.6755C22.3916 21.7475 22.0316 21.8195 21.5996 21.9635V19.2275C21.9596 19.0835 22.3916 19.0115 22.8236 18.9395Z",
    fill: "#AE974E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5997 19.2266V21.9626C21.0957 22.1066 20.5917 22.3226 20.1597 22.6106V19.8746C20.5917 19.5866 21.0957 19.3706 21.5997 19.2266Z",
    fill: "#B39B51"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.144 20.8086V23.5446L26.856 23.6886V20.9526L27.144 20.8086Z",
    fill: "#BB9C47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.576 21.0246V23.7606L27.144 23.5446V20.8086L27.576 21.0246Z",
    fill: "#826C31"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 20,
    width: 4,
    height: 5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6879 24.2643C23.8319 21.6003 23.3279 21.3843 24.1919 20.9523C24.9839 20.5203 26.0639 20.5923 26.8559 21.0243V23.7603C25.1999 22.8243 23.6879 23.6883 23.6879 24.2643Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8554 20.9545V23.6905C26.7834 23.6185 26.6394 23.6185 26.5674 23.5465V20.8105C26.6394 20.8825 26.7114 20.9545 26.8554 20.9545Z",
    fill: "#7E6930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5673 20.8103V23.5463C26.4953 23.4743 26.3513 23.4743 26.2793 23.4743V20.7383C26.3513 20.8103 26.4233 20.8103 26.5673 20.8103Z",
    fill: "#836D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2795 20.738V23.474C26.2075 23.474 26.1355 23.402 26.0635 23.402V20.666C26.1355 20.738 26.2075 20.738 26.2795 20.738Z",
    fill: "#887134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0637 20.666V23.402C25.9917 23.402 25.9197 23.402 25.8477 23.402V20.666C25.9197 20.666 25.9917 20.666 26.0637 20.666Z",
    fill: "#8C7535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8473 20.666V23.402C25.7753 23.402 25.7033 23.402 25.6313 23.402V20.666C25.7033 20.666 25.7753 20.666 25.8473 20.666Z",
    fill: "#917937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6315 20.666V23.402C25.5595 23.402 25.4875 23.402 25.4155 23.402V20.666C25.4875 20.666 25.5595 20.666 25.6315 20.666Z",
    fill: "#967D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4155 20.5938V23.3298C25.3435 23.3298 25.2715 23.3298 25.2715 23.3298V20.5938C25.3435 20.5938 25.4155 20.5938 25.4155 20.5938Z",
    fill: "#9B813B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2714 20.666V23.402C25.1994 23.402 25.1274 23.402 25.1274 23.402V20.666C25.1274 20.666 25.1994 20.666 25.2714 20.666Z",
    fill: "#A0853D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1276 20.666V23.402C25.0556 23.402 24.9836 23.402 24.9116 23.402V20.666C24.9836 20.666 25.0556 20.666 25.1276 20.666Z",
    fill: "#A5893F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9115 20.666V23.402C24.8395 23.402 24.6955 23.474 24.6235 23.474V20.738C24.6955 20.738 24.7675 20.666 24.9115 20.666Z",
    fill: "#A98D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6234 20.7383V23.4743C24.4794 23.5463 24.3354 23.6183 24.1914 23.6903V20.9543C24.3354 20.8823 24.4794 20.8103 24.6234 20.7383Z",
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1916 20.9531V23.6891C24.1196 23.7611 23.9756 23.8331 23.9756 23.9051V21.1691C23.9756 21.0971 24.0476 21.0251 24.1916 20.9531Z",
    fill: "#A98D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9035 21.0977V23.8337C23.8315 23.8337 23.8315 23.9057 23.8315 23.9057V21.1697C23.8315 21.1697 23.9035 21.1697 23.9035 21.0977Z",
    fill: "#A5893F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8313 21.2422V23.9782L23.7593 24.0502V21.3142L23.8313 21.2422Z",
    fill: "#A0853D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7595 21.3867V24.1227V24.1947C23.7595 21.3147 23.6875 21.4587 23.7595 21.3867Z",
    fill: "#967D39"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 3,
    height: 4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2074 21.3853V24.1213C25.4154 23.7613 24.8394 24.1213 24.8394 24.3373C24.9114 21.4573 24.6954 21.5293 25.0554 21.3133C25.4154 21.0973 25.8474 21.2413 26.2074 21.3853Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2075 21.3845V24.1205C26.1355 24.1205 26.1355 24.1205 26.0635 24.0485V21.3125C26.1355 21.3125 26.1355 21.3845 26.2075 21.3845Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0631 21.3122V24.0482C25.9911 24.0482 25.9191 23.9762 25.9191 23.9762V21.2402C25.9191 21.3122 25.9911 21.3122 26.0631 21.3122ZM25.9191 21.2402V23.9762C25.8471 23.9762 25.8471 23.9762 25.7751 23.9762V21.2402C25.8471 21.2402 25.8471 21.2402 25.9191 21.2402ZM25.7751 21.2402V23.9762H25.7031V21.2402C25.7031 21.2402 25.7751 21.2402 25.7751 21.2402Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7033 21.2402V23.9762H25.6313V21.2402C25.6313 21.2402 25.6313 21.2402 25.7033 21.2402ZM25.6313 21.2402V23.9762C25.5593 23.9762 25.5593 23.9762 25.5593 23.9762V21.2402C25.5593 21.2402 25.5593 21.2402 25.6313 21.2402ZM25.5593 21.2402V23.9762H25.4873L25.5593 21.2402C25.4873 21.2402 25.4873 21.2402 25.5593 21.2402ZM25.4873 21.2402V23.9762H25.4153L25.4873 21.2402C25.4153 21.2402 25.4153 21.2402 25.4873 21.2402ZM25.4153 21.2402V23.9762H25.3433V21.2402C25.3433 21.2402 25.3433 21.2402 25.4153 21.2402Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3434 21.2402V23.9762C25.2714 23.9762 25.2714 23.9762 25.1994 23.9762V21.2402C25.2714 21.2402 25.2714 21.2402 25.3434 21.2402ZM25.1994 21.2402V23.9762C25.1274 23.9762 25.0554 24.0482 25.0554 24.0482V21.3122C25.1274 21.3122 25.1274 21.3122 25.1994 21.2402ZM25.0554 21.3122V24.0482C24.9834 24.0482 24.9834 24.1202 24.9834 24.1202V21.3842C24.9834 21.3842 24.9834 21.3842 25.0554 21.3122ZM24.9114 21.3842V24.1202C24.9114 24.1202 24.9114 24.1202 24.8394 24.1922L24.9114 21.3842C24.9114 21.4562 24.9114 21.4562 24.9114 21.3842Z",
    fill: "#1C1C1C"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2082 21.3848L26.1362 24.1208L25.0562 24.6968V22.0328L26.2082 21.3848Z",
    fill: "#BB9C47"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 2,
    height: 4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0558 24.6953C24.9118 24.5513 24.8398 24.4073 24.8398 24.2633V21.5273C24.8398 21.5993 24.9118 21.7433 25.0558 21.9593C25.0558 22.8233 25.0558 23.9033 25.0558 24.6953Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0558 22.0316V24.7676C24.9118 24.6236 24.8398 24.4796 24.8398 24.3356V21.5996C24.8398 21.6716 24.9118 21.8156 25.0558 22.0316Z",
    fill: "#7E6930"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2078 21.3848L25.1278 22.0328C24.9838 21.8888 24.9118 21.7448 24.9118 21.6008C24.8398 21.3128 25.4158 21.0248 26.2078 21.3848Z",
    fill: "#D1AE4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 21,
    width: 2,
    height: 4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0803 22.2463V24.9823C27.9363 24.5503 27.6483 24.2623 27.2163 23.9743V21.2383C27.6483 21.5263 27.9363 21.8863 28.0803 22.2463Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0803 22.2463V24.9823C27.9363 24.5503 27.6483 24.2623 27.2163 23.9743V21.2383C27.6483 21.5263 27.9363 21.8863 28.0803 22.2463Z",
    fill: "#7E6930"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5358 22.248V24.912L21.5278 24.984V22.248H22.5358Z",
    fill: "#AC9042"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5682 21.5996V24.3356L25.3442 25.0556V22.3196L26.5682 21.5996Z",
    fill: "#1C1C1C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4162 22.3203V25.0563H25.3442V22.3203H25.4162Z",
    fill: "#826C31"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 21,
    width: 2,
    height: 5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0719 22.3177V25.0537C26.9999 24.7657 26.7839 24.5497 26.5679 24.3337V21.5977C26.8559 21.8137 26.9999 22.1017 27.0719 22.3177Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0719 22.3177V25.0537C26.9999 24.7657 26.7839 24.5497 26.5679 24.3337V21.5977C26.8559 21.8137 26.9999 22.1017 27.0719 22.3177Z",
    fill: "#1C1C1C"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0798 22.248V24.984L27.0718 25.056V22.32L28.0798 22.248Z",
    fill: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 3,
    height: 7
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2317 22.5368C19.0077 23.2568 18.4317 24.1928 18.3597 25.1288C18.6477 23.1848 17.4957 21.3848 20.2317 19.8008C20.2317 20.7368 20.2317 21.6008 20.2317 22.5368Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5997 19.2246V21.9606C21.0957 22.1046 20.5917 22.3206 20.1597 22.6086V19.8726C20.5917 19.5846 21.0957 19.3686 21.5997 19.2246Z",
    fill: "#B39B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1597 19.873V22.609C19.8717 22.825 19.5837 22.969 19.3677 23.185V20.449C19.5837 20.233 19.7997 20.017 20.1597 19.873Z",
    fill: "#AE974E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3678 20.4492V23.1852C19.2238 23.3292 19.0798 23.4732 19.0078 23.6172V20.8812C19.0798 20.7372 19.2238 20.5932 19.3678 20.4492Z",
    fill: "#A9924C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9359 20.8809V23.6169C18.8639 23.7609 18.7199 23.8329 18.6479 23.9769V21.2409C18.7919 21.0969 18.8639 21.0249 18.9359 20.8809Z",
    fill: "#A48E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7197 21.2402V23.9762C18.6477 24.1202 18.5757 24.1922 18.5757 24.3362V21.6002C18.5757 21.4562 18.6477 21.3842 18.7197 21.2402Z",
    fill: "#9F8A48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5037 21.5996V24.3356C18.4317 24.4796 18.4317 24.5516 18.4317 24.6956C18.5037 22.0316 18.2877 22.1036 18.5037 21.5996Z",
    fill: "#9A8545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4319 21.9609V24.6969C18.4319 24.8409 18.3599 24.9129 18.3599 25.0569C18.3599 22.3929 18.3599 22.3209 18.4319 21.9609Z",
    fill: "#958143"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 19,
    width: 3,
    height: 7
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0326 25.1288C31.0326 24.1928 30.3846 23.2568 29.1606 22.5368C29.1606 21.6008 29.1606 20.7368 29.1606 19.8008C30.3846 20.5208 31.0326 21.4568 31.0326 22.3928C31.0326 23.2568 31.0326 24.3368 31.0326 25.1288Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0321 22.3931V25.1291C31.0321 23.6891 29.5921 22.6091 28.2241 22.1051V19.3691C28.5121 19.5131 28.8721 19.6571 29.1601 19.8011C30.3841 20.5211 31.0321 21.4571 31.0321 22.3931Z",
    fill: "#81703A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 21,
    width: 2,
    height: 5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3363 22.4617V25.1977C23.2563 24.1897 23.9043 24.1897 23.7603 21.5977C23.7603 21.8137 23.9763 22.1017 24.3363 22.4617Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3363 22.4617V25.1977C23.9763 24.8377 23.7603 24.5497 23.7603 24.3337V21.5977C23.7603 21.8137 23.9763 22.1017 24.3363 22.4617Z",
    fill: "#1C1C1C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 2,
    height: 4
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1126 23.1821V25.9181C22.8246 25.7021 22.6086 25.3421 22.5366 24.9821V22.2461C22.6086 22.6061 22.7526 22.8941 23.1126 23.1821Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1126 23.1821V25.9181C22.8246 25.7021 22.6086 25.3421 22.5366 24.9821V22.2461C22.6086 22.6061 22.7526 22.8941 23.1126 23.1821Z",
    fill: "#7E6930"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 22,
    width: 1,
    height: 4
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9125 23.1859V25.9219C24.9125 25.8499 24.8405 25.7059 24.6245 25.4899V22.7539C24.7685 22.9699 24.9125 23.1139 24.9125 23.1859Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9125 23.1859V25.9219C24.9125 25.8499 24.8405 25.7059 24.6245 25.4899V22.7539C24.7685 22.9699 24.9125 23.1139 24.9125 23.1859Z",
    fill: "#1C1C1C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 22,
    width: 2,
    height: 4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9915 25.9223C25.9195 25.7063 25.7755 25.4183 25.4155 25.0583V22.3223C26.1355 23.0423 25.9915 22.9703 25.9915 25.9223Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9917 23.2583V25.9943C25.9917 25.6343 25.6318 25.2743 25.3438 25.0583V22.3223C25.6318 22.5383 25.9917 22.9703 25.9917 23.2583Z",
    fill: "#7E6930"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6242 22.752V25.488L23.4722 26.136V23.4L24.6242 22.752Z",
    fill: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 23,
    width: 1,
    height: 4
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9121 23.1855C24.8401 25.9935 25.0561 25.9215 24.6961 26.2095C24.5521 26.2815 24.3361 26.3535 24.1201 26.3535V23.6175C24.4081 23.6175 24.9121 23.4735 24.9121 23.1855Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9119 23.1864C24.8399 29.8824 24.9119 22.2504 24.9119 23.1864V23.1864Z",
    fill: "#8C7535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9119 23.2578C24.8399 23.2578 24.8399 23.3298 24.9119 23.2578V23.2578Z",
    fill: "#9B813B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8401 23.3301V26.0661C24.8401 26.0661 24.8401 26.0661 24.7681 26.1381L24.8401 23.3301Z",
    fill: "#A5893F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7683 23.4023V26.1383L24.6963 26.2103V23.4743L24.7683 23.4023Z",
    fill: "#A98D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6962 23.4746V26.2106C24.6242 26.2106 24.6242 26.2826 24.5522 26.2826V23.5466C24.6242 23.5466 24.6242 23.4746 24.6962 23.4746Z",
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5522 23.5469V26.2829C24.4802 26.2829 24.4802 26.2829 24.4082 26.2829V23.5469C24.4802 23.5469 24.4802 23.5469 24.5522 23.5469Z",
    fill: "#A98D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4079 23.5469V26.2829H24.3359V23.5469H24.4079Z",
    fill: "#A5893F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3362 23.5469V26.2829H24.2642V23.5469C24.2642 23.6189 24.3362 23.6189 24.3362 23.5469Z",
    fill: "#A0853D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2639 23.6191V26.3551H24.1919V23.6191H24.2639Z",
    fill: "#9B813B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1921 23.6191V26.3551C24.1921 26.3551 24.1921 26.3551 24.1201 26.3551L24.1921 23.6191Z",
    fill: "#967D39"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 22,
    width: 2,
    height: 5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3923 23.5421V26.2781C21.8883 25.9181 21.6003 25.4861 21.5283 24.9821V22.2461C21.6003 22.7501 21.8883 23.1821 22.3923 23.5421Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3923 23.5421V26.2781C21.8883 25.9181 21.6003 25.4861 21.5283 24.9821V22.2461C21.6003 22.7501 21.8883 23.1821 22.3923 23.5421Z",
    fill: "#1C1C1C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 2,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1202 23.6167V26.3527C23.9042 26.3527 23.6882 26.2807 23.4722 26.2087V23.4727C23.6882 23.5447 23.9042 23.5447 24.1202 23.6167Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1203 23.6172V26.3532H24.0483L24.1203 23.6172Z",
    fill: "#967D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0481 23.5449V26.2809H23.9761V23.5449C24.0481 23.5449 24.0481 23.5449 24.0481 23.5449Z",
    fill: "#917937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9763 23.5449V26.2809H23.9043V23.5449H23.9763Z",
    fill: "#8C7535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9043 23.5449V26.2809C23.8323 26.2809 23.8323 26.2809 23.7603 26.2809V23.5449C23.8323 23.5449 23.8323 23.5449 23.9043 23.5449Z",
    fill: "#887134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7602 23.5447V26.2807C23.6882 26.2807 23.6162 26.2087 23.6162 26.2087V23.4727C23.6882 23.4727 23.6882 23.4727 23.7602 23.5447Z",
    fill: "#836D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6162 23.4724V26.2084C23.5442 26.2084 23.5442 26.2084 23.4722 26.1364V23.4004C23.5442 23.4004 23.5442 23.4724 23.6162 23.4724Z",
    fill: "#7E6930"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.392 23.5449V26.2809L21.96 26.5689V23.8329L22.392 23.5449Z",
    fill: "#BB9C47"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 23,
    width: 5,
    height: 4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.992 23.2559C25.848 25.9199 26.352 26.1359 25.488 26.5679C25.128 26.7839 24.696 26.8559 24.192 26.8559C23.688 26.8559 23.256 26.7119 22.752 26.4959V23.7599C24.48 24.6959 25.992 23.8319 25.992 23.2559Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9921 23.2559C25.9921 22.5359 25.9921 29.8079 25.9921 23.2559V23.2559ZM25.9921 23.2559C25.9921 26.1359 25.9921 25.9919 25.9921 26.0639C25.9921 25.3439 25.9921 23.7599 25.9921 23.2559ZM25.9921 23.3279C25.9921 26.2079 25.9921 25.9919 25.9921 26.1359V23.3279C25.9921 23.3999 25.9921 23.3999 25.9921 23.3279ZM25.9921 23.3999V26.1359V26.2079V23.4719C25.9921 23.4719 25.9921 23.4719 25.9921 23.3999ZM25.9201 23.4719V26.2079C25.9201 26.2079 25.9201 26.2799 25.8481 26.2799V23.5439C25.9201 23.5439 25.9201 23.5439 25.9201 23.4719Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9198 23.5449V26.2809L25.8478 26.3529V23.6169C25.8478 23.6169 25.8478 23.6169 25.9198 23.5449ZM25.7758 23.6889V26.4249C25.7038 26.4969 25.6318 26.5689 25.4878 26.6409V23.9049C25.6318 23.8329 25.7038 23.7609 25.7758 23.6889Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5598 23.832V26.568C25.4158 26.64 25.2718 26.712 25.1278 26.784V24.048C25.2718 24.048 25.4158 23.976 25.5598 23.832ZM25.1278 24.048V26.784C25.0558 26.784 24.9118 26.856 24.8398 26.856V24.12C24.9118 24.12 24.9838 24.12 25.1278 24.048ZM24.7678 24.12V26.856C24.6958 26.856 24.6238 26.856 24.5518 26.856V24.12C24.6958 24.192 24.7678 24.12 24.7678 24.12Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6242 24.1914V26.9274C24.5522 26.9274 24.4802 26.9274 24.4802 26.9274V24.1914C24.4802 24.1914 24.5522 24.1914 24.6242 24.1914ZM24.4082 24.1914V26.9274C24.3362 26.9274 24.2642 26.9274 24.2642 26.9274V24.1914C24.3362 24.1914 24.3362 24.1914 24.4082 24.1914Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.264 24.192V26.928C24.192 26.928 24.12 26.928 24.12 26.928V24.192C24.12 24.192 24.192 24.192 24.264 24.192ZM24.12 24.192V26.928C24.048 26.928 23.976 26.928 23.904 26.928V24.192C23.976 24.192 24.048 24.192 24.12 24.192ZM23.904 24.12V26.856C23.832 26.856 23.76 26.856 23.688 26.856V24.12C23.76 24.12 23.832 24.12 23.904 24.12ZM23.688 24.12V26.856C23.616 26.856 23.544 26.856 23.472 26.784V24.048C23.544 24.048 23.616 24.12 23.688 24.12ZM23.472 24.048V26.784C23.4 26.784 23.256 26.712 23.184 26.712V23.976C23.256 23.976 23.328 24.048 23.472 24.048ZM23.112 23.976V26.712C22.968 26.64 22.896 26.64 22.752 26.568V23.832C22.896 23.832 23.04 23.904 23.112 23.976Z",
    fill: "#1C1C1C"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4881 23.9041C24.6961 24.3361 23.6161 24.2641 22.7521 23.8321L22.3201 24.0481L21.8881 23.8321L22.3201 23.5441C21.8161 23.1841 21.5281 22.7521 21.4561 22.2481L22.4641 22.1761C22.5361 22.5361 22.6801 22.8961 23.0401 23.1121L24.2641 22.3921C23.4001 21.6001 23.5441 21.2401 24.1921 20.8801C24.9841 20.4481 26.0641 20.5201 26.8561 20.9521L27.1441 20.7361L27.5761 20.9521L27.2881 21.1681C27.7201 21.4561 28.0081 21.8161 28.1521 22.1761L27.0721 22.3201C27.0001 22.0321 26.7841 21.8161 26.5681 21.6001L25.4161 22.3201C26.2801 23.1121 26.1361 23.5441 25.4881 23.9041ZM24.1201 23.6161C24.4081 23.6161 24.9121 23.4721 24.9121 23.2561C24.9121 23.1841 24.8401 23.0401 24.6241 22.8241L23.4721 23.4721C23.6881 23.5441 23.9041 23.5441 24.1201 23.6161ZM25.0561 22.0321L26.1361 21.3841C25.3441 21.0241 24.7681 21.3841 24.7681 21.6001C24.8401 21.6721 24.9121 21.8161 25.0561 22.0321Z",
    fill: "#F2CA5C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8238 23.832V26.496L22.3198 26.784V24.048L22.8238 23.832Z",
    fill: "#1C1C1C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 24.048V26.784L21.96 26.568V23.832L22.32 24.048Z",
    fill: "#1C1C1C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4558 19.0071C33.6958 20.8791 33.6958 25.9911 30.5278 27.8631C27.3598 29.7351 22.1758 29.8791 18.9358 28.0791C15.7678 26.2071 15.6958 20.9511 18.9358 19.0791C22.1038 17.2071 27.2158 17.2071 30.4558 19.0071ZM20.2318 24.9831C22.6798 26.4231 26.7118 26.4231 29.1598 24.9831C31.6078 23.5431 31.6078 21.2391 29.0878 19.7991C26.6398 18.3591 22.6078 18.3591 20.1598 19.7991C17.7838 21.2391 17.7838 23.5431 20.2318 24.9831Z",
    fill: "#F8D770"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1598 19.8007C31.6078 21.2407 31.6798 23.5447 29.2318 24.9847C26.7838 26.4247 22.7518 26.4247 20.3038 24.9847C17.8558 23.5447 17.8558 21.2407 20.3038 19.8007C22.6798 18.3607 26.6398 18.3607 29.1598 19.8007ZM24.1918 24.1927C24.9118 24.1927 26.0638 23.8327 25.9918 23.1847C25.9198 22.7527 25.4158 22.3927 25.3438 22.3207L26.4958 21.6007C26.7838 21.8167 26.9278 22.0327 26.9998 22.3207L28.0078 22.2487C27.8638 21.8167 27.5758 21.5287 27.1438 21.2407L27.4318 21.0247L26.9998 20.8087L26.7118 21.0247C25.9198 20.5927 24.8398 20.5207 24.0478 20.9527C23.3998 21.3127 23.3278 21.6727 24.1198 22.4647L22.8958 23.1847C22.6078 22.9687 22.3918 22.6087 22.3198 22.2487L21.3118 22.3207C21.3838 22.8247 21.6718 23.2567 22.1758 23.6167L21.7438 23.9047L22.1758 24.1207L22.6078 23.8327C23.2558 24.0487 23.7598 24.1927 24.1918 24.1927Z",
    fill: "#F2CA5C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6242 22.752L23.4722 23.4C23.8322 23.544 24.3362 23.688 24.6962 23.472C25.0562 23.256 24.9122 23.04 24.6242 22.752Z",
    fill: "#D1AE4F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0321 21.5278V22.4638C31.0321 21.5278 30.3841 20.5918 29.1601 19.8718C25.2001 17.5678 18.4321 19.1518 18.4321 22.4638V21.5278C18.4321 18.2878 25.2721 16.7038 29.1601 18.9358C30.3841 19.6558 31.0321 20.5918 31.0321 21.5278Z",
    fill: "#E2B647"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5758 20.1602V21.0962L27.2158 21.2402V20.3762L27.5758 20.1602Z",
    fill: "#E2B647"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2078 20.5191V21.4551C25.4158 21.0951 24.8398 21.4551 24.8398 21.6711C24.9118 20.8071 24.6958 20.6631 25.0558 20.5191C25.3438 20.3031 25.8478 20.3751 26.2078 20.5191Z",
    fill: "#E2B647"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5682 20.7363V21.6723L25.3442 22.3923V21.4563L26.5682 20.7363Z",
    fill: "#E2B647"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0719 21.5286V22.4646C26.9999 22.1766 26.7839 21.9606 26.5679 21.7446V20.8086C26.8559 20.9526 26.9999 21.2406 27.0719 21.5286Z",
    fill: "#F2CA5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 20,
    width: 2,
    height: 3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0724 21.5305V22.4665C27.0004 22.1785 26.7844 21.9625 26.5684 21.7465V20.8105C26.8564 20.9545 27.0004 21.2425 27.0724 21.5305Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0724 21.5305V22.4665C27.0004 22.1785 26.7844 21.9625 26.5684 21.7465V20.8105C26.8564 20.9545 27.0004 21.2425 27.0724 21.5305Z",
    fill: "#D1A543"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0798 21.3848V22.3208L27.0718 22.3928V21.5288L28.0798 21.3848Z",
    fill: "#E2B647"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3358 21.6003V22.5363C23.9758 22.1763 23.7598 21.8883 23.7598 21.6723V20.7363C23.7598 20.9523 23.9758 21.2403 24.3358 21.6003Z",
    fill: "#E2B647"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 1,
    height: 3
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9125 22.3187V23.2547C24.9125 23.1827 24.8405 23.0387 24.6245 22.8227V21.8867C24.7685 22.1027 24.9125 22.2467 24.9125 22.3187Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9125 22.3187V23.2547C24.9125 23.1827 24.8405 23.0387 24.6245 22.8227V21.8867C24.7685 22.1027 24.9125 22.2467 24.9125 22.3187Z",
    fill: "#D1A543"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6242 21.8887V22.8247L23.4722 23.4727V22.5367L24.6242 21.8887Z",
    fill: "#E2B647"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 2,
    height: 3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3918 22.6808V23.6168C21.8878 23.2568 21.5998 22.8248 21.5278 22.3208V21.3848C21.5998 21.8888 21.8878 22.3208 22.3918 22.6808Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3918 22.6808V23.6168C21.8878 23.2568 21.5998 22.8248 21.5278 22.3208V21.3848C21.5998 21.8888 21.8878 22.3208 22.3918 22.6808Z",
    fill: "#E2B647"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8238 22.9688V23.8327L22.3198 24.1208V23.1848L22.8238 22.9688Z",
    fill: "#D1A543"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 23.1848V24.1208L21.96 23.9048V22.9688L22.32 23.1848Z",
    fill: "#E2B647"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.992 22.3926C25.92 23.1846 26.28 23.4726 25.488 23.9046C24.696 24.3366 23.616 24.2646 22.752 23.8326V22.8966C24.48 23.8326 25.992 22.9686 25.992 22.3926Z",
    fill: "#E2B647"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4881 23.0402C24.6961 23.4722 23.6161 23.4002 22.7521 22.9682L22.3201 23.1842L21.8881 22.9682L22.3201 22.6802C21.8161 22.3202 21.5281 21.8882 21.4561 21.3842L22.4641 21.3122C22.5361 21.6722 22.6801 22.0322 23.0401 22.2482L24.2641 21.5282C23.9041 21.1682 23.6881 20.8802 23.6881 20.6642C23.6161 20.0882 25.1281 19.1522 26.8561 20.0162L27.1441 19.8002L27.5761 20.0162L27.2881 20.2322C27.7201 20.5202 28.0081 20.8802 28.1521 21.2402L27.1441 21.3122C27.0721 21.0242 26.8561 20.8082 26.6401 20.5922L25.4881 21.3122C26.2801 22.2482 26.1361 22.6802 25.4881 23.0402ZM24.1201 22.7522C24.4081 22.7522 24.9121 22.6082 24.8401 22.3922C24.8401 22.3202 24.7681 22.1762 24.5521 21.9602L23.4001 22.6082C23.6881 22.6802 23.9041 22.7522 24.1201 22.7522ZM25.0561 21.1682L26.1361 20.5202C25.4161 20.1602 24.4081 20.4482 25.0561 21.1682Z",
    fill: "#F8D770"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9038 21.5273V24.7673C32.9038 25.9913 32.1118 27.1433 30.5278 28.0793C27.3598 29.9513 22.1758 29.9513 18.9358 28.0793C17.3518 27.1433 16.4878 25.7033 16.4878 24.5513V21.5273C16.4878 25.7753 25.4158 27.8633 30.4558 24.9113C32.1118 23.9033 32.8318 22.6793 32.9038 21.5273Z",
    fill: "#F2CA5C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4562 18.1442C33.6242 20.0162 33.6962 22.9682 30.5282 24.8402C27.3602 26.7122 22.1762 26.7122 18.9362 24.8402C15.7682 22.9682 15.6962 20.0162 18.8642 18.1442C22.1042 16.2722 27.2882 16.2722 30.4562 18.1442ZM20.2322 24.0482C22.6802 25.4882 26.7122 25.4882 29.1602 24.0482C31.6082 22.6082 31.6082 20.3042 29.0882 18.8642C26.6402 17.4242 22.6082 17.4242 20.1602 18.8642C17.7842 20.3042 17.7842 22.6082 20.2322 24.0482Z",
    fill: "#F8D770"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3041 11.735C20.2321 11.591 20.4481 9.86304 17.9281 8.35104C12.8881 5.39904 4.03212 7.41504 4.03212 11.663C4.32012 13.751 2.95212 16.055 6.40812 18.071C6.84012 18.359 7.34412 18.503 7.84812 18.719C13.1041 20.663 20.3041 18.575 20.3041 14.759C20.3041 14.687 20.3041 11.663 20.3041 11.735ZM4.17612 12.527C4.10412 12.383 4.10412 12.383 4.17612 12.527V12.527Z",
    fill: "#F2CA5C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9599 12.3836L11.8799 11.7356L13.1759 11.0156L14.2559 11.6636C14.5439 11.8076 14.7599 12.0236 14.7599 12.1676C14.8319 12.4556 14.1119 13.1036 12.9599 12.3836Z",
    fill: "#F2CA5C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0401 13.8953C14.0401 14.1113 13.8241 14.3273 13.5361 14.4713C13.1761 14.6873 12.7441 14.7593 12.3121 14.7593C11.7361 14.7593 11.0881 14.6153 10.4401 14.2553L9.79211 14.6153L9.00011 14.1833L9.64811 13.8233L9.28811 13.6073L8.64011 13.9673L7.92011 13.5353L8.56811 13.1753C8.49611 13.1033 7.70411 12.6713 7.77611 12.6713L8.56811 12.2393L9.07211 12.5273L12.4561 10.5833L11.9521 10.2953L12.7441 9.86328C12.8161 9.93528 13.6081 10.3673 13.5361 10.2953L14.1841 9.93528L14.9761 10.3673L14.1841 10.7993L14.5441 11.0153L15.1921 10.6553L15.9841 11.0873L15.3361 11.4473C15.5521 11.5913 15.6961 11.7353 15.8401 11.8793C15.9841 12.0953 16.0561 12.2393 16.0561 12.3833C16.0561 12.6713 15.8401 12.8873 15.5521 13.1033C15.1921 13.3193 14.7601 13.4633 14.3281 13.3913H14.0401L13.6801 13.1753C13.9681 13.3913 14.0401 13.6793 14.0401 13.8953ZM11.9521 14.1113C12.2401 14.1833 12.4561 14.1113 12.7441 13.9673C13.1761 13.7513 13.0321 13.3913 12.3121 12.9593L11.0881 12.2393L9.72011 13.0313L11.0161 13.7513C11.4481 13.9673 11.7361 14.0393 11.9521 14.1113ZM13.1761 11.0873L11.8801 11.8073L12.9601 12.4553C14.1121 13.1033 14.8321 12.5273 14.7601 12.1673C14.6881 12.0233 14.5441 11.8793 14.2561 11.6633L13.1761 11.0873Z",
    fill: "#F2CA5C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M12.312 12.9602C13.032 13.3922 13.176 13.6802 12.744 13.9682C12.456 14.1122 12.24 14.1842 11.952 14.1122C11.664 14.0402 11.376 13.9682 11.088 13.7522L9.79199 13.0322L11.16 12.2402L12.312 12.9602Z",
    fill: "#F2CA5C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4879 9.93547C18.9359 11.3035 18.9359 13.6075 16.5599 14.9755C14.1119 16.3435 10.2239 16.3435 7.77594 14.9755C5.32794 13.6075 5.32794 11.3035 7.77594 9.93547C10.1519 8.49547 14.1119 8.49547 16.4879 9.93547ZM12.2399 14.8315C12.7439 14.8315 13.1759 14.6875 13.4639 14.5435C13.7519 14.3275 13.9679 14.1835 13.9679 13.9675C13.9679 13.7515 13.8959 13.5355 13.6799 13.3195L13.9679 13.3915H14.2559C14.6879 13.4635 15.1199 13.3195 15.4799 13.1035C15.7679 12.8875 15.9839 12.6715 15.9839 12.3835C15.9839 12.2395 15.9119 12.0955 15.7679 11.8795C15.6959 11.7355 15.4799 11.5915 15.2639 11.4475L15.9119 11.0875L15.1199 10.6555L14.4719 11.0155L14.1839 10.7995L14.8319 10.4395L14.0399 10.0075L13.3919 10.3675C13.3199 10.2955 12.5279 9.86347 12.5999 9.93547L11.8079 10.3675L12.3119 10.6555L8.92794 12.5995L8.49594 12.2395L7.70394 12.6715C7.77594 12.7435 8.56794 13.1755 8.49594 13.1755L7.91994 13.5355L8.71194 13.9675L9.35994 13.6075L9.71994 13.8235L9.07194 14.1835L9.86394 14.6155L10.5119 14.2555C11.0879 14.6155 11.6639 14.8315 12.2399 14.8315Z",
    fill: "#F2CA5C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9282 9.07266C21.0962 10.9447 21.1682 13.8967 18.0002 15.7687C14.8322 17.6407 9.64822 17.6407 6.48022 15.7687C3.31222 13.8967 3.24022 10.9447 6.48022 9.07266C9.57622 7.27266 14.6882 7.27266 17.9282 9.07266ZM7.77622 14.9767C10.2242 16.3447 14.1122 16.3447 16.5602 14.9767C18.9362 13.6087 18.9362 11.3047 16.4882 9.93666C14.0402 8.56866 10.1522 8.56866 7.77622 9.93666C5.40022 11.3047 5.40022 13.5367 7.77622 14.9767Z",
    fill: "#D6B961"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3601 11.3037V12.4557C18.3601 9.21567 11.6641 7.70367 7.77607 9.93567C6.55207 10.6557 5.97607 11.5197 5.97607 12.4557C6.12007 11.8077 5.40007 10.1517 7.77607 8.78367C11.6641 6.55167 18.3601 8.06367 18.3601 11.3037Z",
    fill: "#E2B647"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M20.304 11.3044C20.16 11.8804 21.024 14.0404 17.928 15.7684C12.888 18.7204 3.95996 16.6324 3.95996 12.3844V11.2324C3.95996 15.4804 12.816 17.5684 17.928 14.6164C19.512 13.6804 20.304 12.5284 20.304 11.3044Z",
    fill: "#F2CA5C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9279 7.9201C21.0959 9.7921 21.0959 12.7441 17.9279 14.6161C14.7599 16.4881 9.57591 16.4881 6.40791 14.6161C3.23991 12.7441 3.16791 9.7921 6.33591 7.9201C9.50391 6.0481 14.7599 6.1201 17.9279 7.9201ZM7.84791 13.8241C10.2959 15.1921 14.1839 15.1921 16.5599 13.8241C19.0079 12.4561 18.9359 10.1521 16.5599 8.7841C14.1119 7.4161 10.2239 7.4161 7.77591 8.7841C5.39991 10.1521 5.39991 12.3841 7.84791 13.8241Z",
    fill: "#F8D770"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07218 11.8801V12.8881L8.78418 12.6721V11.6641L9.07218 11.8801Z",
    fill: "#D1A543"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3841 9.64737V10.5834L11.9521 10.3674V9.35938L12.3841 9.64737Z",
    fill: "#D1A543"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5438 9.43164V10.4396L13.9678 10.7996V9.79164L14.5438 9.43164Z",
    fill: "#E2B647"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4798 10.0078V11.0158L14.9038 11.3038V10.3678L15.4798 10.0078Z",
    fill: "#E2B647"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 10.5838V11.5918L13.104 11.0158V10.0078L14.04 10.5838Z",
    fill: "#D1A543"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1039 10.0078V11.0158L12.0239 11.6638V10.6558L13.1039 10.0078Z",
    fill: "#E2B647"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M14.472 10.9437V11.9517C14.4 11.8077 14.256 11.6637 14.04 11.5197V10.5117C14.328 10.7277 14.472 10.8717 14.472 10.9437Z",
    fill: "#D1A543"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12.384 11.6639V12.6719L11.376 12.0239V11.0879L12.384 11.6639Z",
    fill: "#D1A543"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78383 11.6633V12.6713L8.42383 12.4553V11.4473L8.78383 11.6633Z",
    fill: "#D1A543"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3761 11.0879V12.0239L10.2241 12.7439V11.7359L11.3761 11.0879Z",
    fill: "#E2B647"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7521 11.9529V12.9609L13.5361 12.8889V11.8809L13.7521 11.9529Z",
    fill: "#E2B647"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 11.9512V12.9592H13.752V11.9512H14.04Z",
    fill: "#E2B647"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M15.552 11.0879C15.48 11.8079 15.84 12.3119 15.12 12.6719C14.76 12.8879 14.4 12.9599 14.04 12.8879V11.8799C14.4 11.8799 14.76 11.8079 15.12 11.6639C15.408 11.5199 15.552 11.3759 15.552 11.0879Z",
    fill: "#E2B647"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9598 12.2401V13.2481C12.9598 13.1041 12.7438 12.8881 12.3838 12.6721V11.6641C12.7438 11.8801 12.9598 12.0241 12.9598 12.2401Z",
    fill: "#D1A543"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0802 12.3842L10.0082 13.3922L9.72021 13.2482L9.79222 12.2402L10.0802 12.3842Z",
    fill: "#D1A543"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21587 12.528V13.536L8.56787 13.176V12.168L9.21587 12.528Z",
    fill: "#D1A543"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79182 12.2402L9.71982 13.2482L9.21582 13.5362V12.5282L9.79182 12.2402Z",
    fill: "#E2B647"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7279 12.8164V13.8244L10.1519 14.1124V13.1044L10.7279 12.8164Z",
    fill: "#E2B647"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1519 13.1041V14.1121L9.50391 13.7521V12.7441L10.1519 13.1041Z",
    fill: "#D1A543"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M13.824 12.4551C13.752 13.1751 14.112 13.6071 13.392 13.9671C13.104 14.1111 12.744 14.2551 12.312 14.2551C11.808 14.2551 11.304 14.1111 10.728 13.8231V12.8151C11.304 13.1751 11.808 13.3191 12.312 13.2471C12.744 13.2471 13.104 13.1031 13.392 12.9591C13.68 12.8151 13.824 12.6711 13.824 12.4551Z",
    fill: "#E2B647"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M12.312 13.248C11.808 13.248 11.304 13.104 10.728 12.816L10.152 13.104L9.504 12.744L10.008 12.456L9.792 12.24L9.288 12.528L8.64 12.168L9.144 11.88C9.072 11.808 8.352 11.448 8.424 11.448L9.072 11.088L9.504 11.304L12.456 9.576L11.952 9.36L12.6 9C12.672 9.072 13.392 9.432 13.32 9.432L13.824 9.144L14.472 9.504L13.968 9.792L14.256 9.936L14.76 9.648L15.408 10.008L14.832 10.296C15.624 10.8 15.624 11.304 14.976 11.664C14.616 11.88 14.256 11.952 13.896 11.88H13.608L13.392 11.808C14.328 12.528 13.392 13.248 12.312 13.248ZM12.024 12.672C12.24 12.672 12.456 12.672 12.744 12.528C13.104 12.312 13.032 12.024 12.384 11.664L11.376 11.088L10.224 11.736L11.376 12.384C11.592 12.528 11.808 12.6 12.024 12.672ZM13.104 10.008L12.024 10.656C12.672 10.944 13.536 11.736 14.256 11.304C15.048 10.872 13.824 10.512 13.104 10.008Z",
    fill: "#F8D770"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62416 19.0801V22.3201C6.62416 22.4641 6.48016 22.5361 6.26416 22.5361V19.2961C6.40816 19.2961 6.62416 19.1521 6.62416 19.0801Z",
    fill: "#73BD1E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19182 19.2949V22.4629H5.11182V19.2949H6.19182Z",
    fill: "#73BD1E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52008 19.2949L2.44808 22.4629H1.08008L1.15208 19.2949H2.52008Z",
    fill: "#73BD1E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0.720215 22.2478V19.0078C0.720215 19.0798 0.792215 19.1518 0.864215 19.1518C0.936215 19.2238 1.00821 19.2238 1.15221 19.2238V22.4638C1.00821 22.4638 0.936215 22.4638 0.864215 22.3918C0.792215 22.3918 0.720215 22.3198 0.720215 22.2478Z",
    fill: "#73BD1E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6081 25.1289V28.3689H13.3921V25.1289H13.6081Z",
    fill: "#61A01D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3922 25.1289V28.3689C12.3842 28.3689 8.35224 28.2249 5.40024 26.5689C3.67224 25.5609 2.66424 24.1929 2.44824 22.5369V19.2969C2.66424 20.9529 3.60024 22.3209 5.40024 23.3289C8.35224 25.0569 12.3842 25.1289 13.3922 25.1289Z",
    fill: "#61A01D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1564_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 19,
    width: 12,
    height: 10
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3918 25.1269V28.3669C12.3838 28.3669 8.35175 28.2229 5.39975 26.5669C3.67175 25.5589 2.66375 24.1909 2.44775 22.5349V19.2949C2.66375 20.9509 3.59975 22.3189 5.39975 23.3269C8.35175 25.0549 12.3838 25.1269 13.3918 25.1269Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1564_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.392 25.127V28.367C13.32 28.367 13.176 28.367 12.96 28.367V25.127C13.176 25.127 13.32 25.127 13.392 25.127Z",
    fill: "#61A01D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0319 25.1262V28.3662C12.7439 28.3662 12.3119 28.3662 11.8079 28.2942V25.0542C12.2399 25.1262 12.6719 25.1262 13.0319 25.1262ZM11.7359 25.0542V28.2942C11.3759 28.2942 10.9439 28.2222 10.4399 28.1502V24.9102C10.9439 24.9822 11.3759 25.0542 11.7359 25.0542Z",
    fill: "#61A01D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5118 24.9106V28.1506C10.1518 28.0786 9.71984 28.0066 9.28784 27.9346V24.6946C9.64784 24.8386 10.0798 24.9106 10.5118 24.9106ZM9.28784 24.6946V27.9346C8.92784 27.8626 8.49584 27.7906 8.06384 27.6466V24.4066C8.49584 24.5506 8.85584 24.6226 9.28784 24.6946ZM8.06384 24.4066V27.6466C7.63184 27.5026 7.19984 27.3586 6.83984 27.2146V23.9746C7.19984 24.1906 7.63184 24.3346 8.06384 24.4066Z",
    fill: "#61A01D"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47986 18.865C6.69586 19.009 6.55186 19.225 6.19186 19.225H5.11186C5.32786 20.521 6.04786 21.529 7.27186 22.249C9.71986 23.689 13.4639 23.617 13.5359 23.617L13.6799 25.129H13.4639C12.4559 25.129 8.42386 24.985 5.47186 23.329C3.74386 22.321 2.73586 20.953 2.51986 19.297H1.15186C1.00786 19.297 0.935859 19.297 0.863859 19.225C0.719859 19.153 0.719859 19.009 0.863859 18.937C3.16786 17.713 3.45586 17.209 3.95986 17.497L6.47986 18.865Z",
    fill: "#83CC25"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.60f4b8ff25e4cbcf96f491060a7f72d5.svg";
export { ForwardRef as ReactComponent };